export const getProductUrlWithSwatchOption = (
  existingProductUrl: string,
  selectedSwatchOptionToken?: string
): string => {
  if (selectedSwatchOptionToken) {
    const separator = existingProductUrl.includes("?") ? "&" : "?";
    return `${existingProductUrl}${separator}productOptionToken=${selectedSwatchOptionToken}`;
  }
  return existingProductUrl;
};
